import Box from '@mui/material/Box'
import React, { useCallback, useContext, useState } from 'react'
import { Navigate } from 'react-router-dom'

import { AccountVerificationForm } from 'components/Auth/AccountVerificationForm'
import { PhoneForm } from 'components/Auth/PhoneForm'
import { PhoneVerificaionForm } from 'components/Auth/PhoneVerificaionForm'
import { RegisterAccountForm } from 'components/Auth/RegisterAccountForm'
import { UserContext } from 'context/user'
import AuthLayout from 'layouts/authLayout'
import routes from 'routes'
import { checkCookie, setCookie } from 'utils/helper'


export const SignUp = () => {
  const user = useContext(UserContext)
  const [currentStep, setCurrentStep] = useState(0)

  const onNextStep = useCallback(() => setCurrentStep(currStep => currStep + 1), [])

  if (user) {
    if (user) {
      if (checkCookie(user.email, user.id)) {
        return <Navigate to={routes.home} />
      } else {
        setCookie(user.email, user.id, 365)
        return <Navigate to={'/walkthrough'} />
      }
    }
  }

  return (
    <AuthLayout bgType="signUp">
      <div className='customAuthInput px-5 mt-5'>
        {currentStep === 0 && <RegisterAccountForm onNextStep={onNextStep} />}
        {currentStep === 1 && <Box style={{ margin: 'auto' }} width='50%'><AccountVerificationForm onNextStep={onNextStep} /></Box>}
        {currentStep === 2 && <PhoneForm onNextStep={onNextStep} />}
        {currentStep === 3 && <PhoneVerificaionForm onNextStep={onNextStep} />}
      </div>
    </AuthLayout>
  )
}
